/**
 * Warehouse Insights API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Action } from './action';
import { InsightInteractionState } from './insightInteractionState';
import { Tab } from './tab';
import { Confidence } from './confidence';
import { Delta } from './delta';
import { InsightFeedback } from './insightFeedback';


/**
 * The full drill-through view behind a summary card: a richer description plus the tabbed content (Overview, Evidence, Benchmarks, History, Trend) that lets the user explore the supporting data.
 */
export interface InsightDetail { 
    /**
     * Stable unique identifier for the insight; matches the summary card `id`.
     */
    id: string;
    /**
     * Title of the detail view, for example \'Repeat-offender operators\'.
     */
    title: string;
    /**
     * Narrative paragraph introducing the detail view and its scope.
     */
    description: string;
    /**
     * Overall urgency of the insight, driving accent colour. \'error\' is most urgent, \'warning\' needs attention, \'info\' is neutral, \'success\' is positive.
     */
    severity: InsightDetail.SeverityEnum;
    /**
     * The analysis window the insight covers, expressed as a human-readable label such as \'30 days\'.
     */
    timeWindow: string;
    /**
     * Inclusive start of the analysis window as an ISO 8601 timestamp, or null when unknown.
     */
    windowStart?: string | null;
    /**
     * Inclusive end of the analysis window as an ISO 8601 timestamp, or null when unknown.
     */
    windowEnd?: string | null;
    /**
     * How much the system trusts this insight, given the supporting data.
     */
    confidence: Confidence;
    /**
     * Optional period-over-period movement in the insight\'s headline metric, for example a 15.1% rise versus the prior 30 days. Renders as a delta arrow in the detail header; omitted when no comparison window is available.
     */
    trend?: Delta | null;
    /**
     * Suggested actions offered on the detail view, such as \'Ask Aura\' prompts.
     */
    actions?: Array<Action>;
    /**
     * Ordered drill-through tabs, normally Overview, Evidence, Benchmarks, History, Trend.
     */
    tabs: Array<Tab>;
    /**
     * The caller\'s own quality rating of this occurrence, or None if unrated.
     */
    feedback?: InsightFeedback | null;
    /**
     * The caller\'s own interactions (dismissed/favourited/seen/acknowledged) with this occurrence, or None if the caller has none recorded.
     */
    interactions?: InsightInteractionState | null;
}
export namespace InsightDetail {
    export const SeverityEnum = {
        Warning: 'warning',
        Error: 'error',
        Info: 'info',
        Success: 'success'
    } as const;
    export type SeverityEnum = typeof SeverityEnum[keyof typeof SeverityEnum];
}


